var Haiku = require("@haiku/core");
var _code_purp_code = require("./../purp/code.js");
var _code_blue_code = require("./../blue/code.js");
var _code_orange_code = require("./../orange/code.js");
var _code_green_code = require("./../green/code.js");
var _code_pink_code = require("./../pink/code.js");
module.exports = {
  metadata: {
    version: "0.0.21",
    username: "taylor+taylor@haiku.ai",
    organization: "taylor",
    project: "heroine",
    branch: "master",
    folder: "/Users/taylorpoe/.haiku/projects/taylor/heroine",
    uuid: "ad18a731-ed77-4085-88b7-419d3fe4f2f8",
    root: "https://cdn.haiku.ai/e062580c-8941-425f-9ce7-f01d8d3a6bef/07ee961d5f9b270810efecb4f5013685c38388c4/",
    core: "4.3.0",
    title: "Uifaux",
    type: "haiku",
    relpath: "code/uifaux/code.js"
  },
  options: {},
  states: {
    lift: { type: "number", value: 20, edited: true },
    finished: { type: "boolean", value: false, edited: true }
  },
  eventHandlers: {
    "haiku:Uifaux-0f23afdde00ee0c7": {
      playKids: {
        handler: function(component, element, target, event) {
          let name = arguments[1];
          let upcaseName = name.charAt(0).toUpperCase() + name.substr(1);
          let evtName = "play" + upcaseName;
          setTimeout(() => {
            this.send("down", evtName);
          }, 400);
        }
      }
    }
  },
  timelines: {
    Default: {
      "haiku:Uifaux-0f23afdde00ee0c7": {
        "style.WebkitTapHighlightColor": "rgba(0,0,0,0)",
        "style.position": "relative",
        "style.overflowX": "visible",
        "style.overflowY": "visible",
        "sizeAbsolute.x": 674,
        "sizeAbsolute.y": 443,
        "sizeMode.x": 1,
        "sizeMode.y": 1,
        "sizeMode.z": 1,
        "style.transformStyle": { "0": { value: "preserve-3d", edited: true } }
      },
      "haiku:Ui-Bg-9bb8f6217143b6a1": {
        "style.overflow": "visible",
        "style.position": "absolute",
        "style.margin": "0",
        "style.padding": "0",
        "style.border": "0",
        "translation.x": 337,
        "translation.y": 182,
        "sizeAbsolute.x": 552,
        "sizeMode.x": 1,
        "sizeAbsolute.y": 396,
        "sizeMode.y": 1,
        "style.zIndex": 1
      },
      "haiku:E2d7f469247f-D1e397-Filter-1-44e748-0df86d82f849da31": {
        x: "-17.0%",
        y: "-23.2%",
        width: "134.1%",
        height: "147.5%",
        filterUnits: "objectBoundingBox"
      },
      "haiku:Fe-Offset-3f4caa263e34fb2a": {
        dx: 0,
        dy: 2,
        in: "SourceAlpha",
        result: "shadowOffsetOuter1"
      },
      "haiku:Fe-Gaussian-Blur-f7e18da0b66d08a5": {
        stdDeviation: 31,
        in: "shadowOffsetOuter1",
        result: "shadowBlurOuter1"
      },
      "haiku:Fe-Color-Matrix-44d984f0fdda0821": {
        values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
        in: "shadowBlurOuter1",
        result: "shadowMatrixOuter1"
      },
      "haiku:Fe-Merge-Node-4f2044f7f412ba24": { in: "shadowMatrixOuter1" },
      "haiku:Fe-Merge-Node-2c8d1ded813d5d0b": { in: "SourceGraphic" },
      "haiku:Group-8e784ea2e130c70b": {
        filter: "url(#e2d7f469247f-d1e397)",
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        fillRule: "evenodd"
      },
      "haiku:50ea93c31bda-Ui-Bg-ed487866eeb1adb1": {
        fill: "#273234",
        x: 0,
        y: 0,
        width: 552,
        height: 396,
        rx: 16
      },
      "haiku:Slot2-Med-a0d1331f26c4ec66": {
        "style.position": "absolute",
        "sizeAbsolute.y": 88,
        "style.padding": "0",
        "style.border": "0",
        "sizeAbsolute.x": 93,
        "style.margin": "0",
        "sizeMode.x": 1,
        "sizeMode.y": 1,
        "translation.x": 147.6,
        "translation.y": 158.8,
        "style.zIndex": 4,
        "translation.z": {
          "0": {
            value: Haiku.inject(function(lift) {
              return lift;
            }, "lift"),
            edited: true
          }
        }
      },
      "haiku:Slot2-Med-6b3dea5432aece33": {
        "style.position": "absolute",
        "sizeAbsolute.y": 88,
        "style.padding": "0",
        "style.border": "0",
        "sizeAbsolute.x": 93,
        "style.margin": "0",
        "sizeMode.x": 1,
        "sizeMode.y": 1,
        "translation.x": 402.6,
        "translation.y": 159.8,
        "style.zIndex": 3,
        "translation.z": {
          "0": {
            value: Haiku.inject(function(lift) {
              return lift;
            }, "lift"),
            edited: true
          }
        }
      },
      "haiku:Pink-2d27044ea4bec9d5": {
        "style.position": "absolute",
        "translation.x": 132,
        "style.padding": "0",
        "style.border": "0",
        "sizeMode.x": 1,
        "sizeMode.y": 1,
        "sizeAbsolute.x": "auto",
        "style.margin": "0",
        "sizeAbsolute.y": "auto",
        "translation.y": 74,
        "sizeMode.z": 1,
        "origin.x": 0.5,
        "origin.y": 0.5,
        "style.zIndex": 5,
        playback: "loop",
        "translation.z": {
          "0": {
            value: Haiku.inject(function(lift) {
              return lift;
            }, "lift"),
            edited: true
          }
        },
        finished: {
          "0": {
            value: Haiku.inject(function(finished) {
              return finished;
            }, "finished"),
            edited: true
          }
        }
      },
      "haiku:Green-b274b2bd2601d054": {
        "style.position": "absolute",
        "translation.x": 276.6,
        "style.padding": "0",
        "style.border": "0",
        "sizeMode.x": 1,
        "sizeMode.y": 1,
        "sizeAbsolute.x": "auto",
        "style.margin": "0",
        "sizeAbsolute.y": "auto",
        "translation.y": 160.8,
        "sizeMode.z": 1,
        "origin.x": 0.5,
        "origin.y": 0.5,
        "style.zIndex": 6,
        playback: "loop",
        "translation.z": {
          "0": {
            value: Haiku.inject(function(lift) {
              return lift;
            }, "lift"),
            edited: true
          }
        },
        finished: {
          "0": {
            value: Haiku.inject(function(finished) {
              return finished;
            }, "finished"),
            edited: true
          }
        }
      },
      "haiku:Orange-4eee4f9f4c68dc3e": {
        "style.position": "absolute",
        "translation.x": 525.0999755859375,
        "style.padding": "0",
        "style.border": "0",
        "sizeMode.x": 1,
        "sizeMode.y": 1,
        "sizeAbsolute.x": "auto",
        "style.margin": "0",
        "sizeAbsolute.y": "auto",
        "translation.y": 161.3,
        "sizeMode.z": 1,
        "origin.x": 0.5,
        "origin.y": 0.5,
        "style.zIndex": 7,
        playback: "loop",
        "translation.z": {
          "0": {
            value: Haiku.inject(function(lift) {
              return lift;
            }, "lift"),
            edited: true
          }
        },
        finished: {
          "0": {
            value: Haiku.inject(function(finished) {
              return finished;
            }, "finished"),
            edited: true
          }
        }
      },
      "haiku:Blue-9c088d58dfed69fd": {
        "style.position": "absolute",
        "translation.x": 458.6,
        "style.padding": "0",
        "style.border": "0",
        "sizeMode.x": 1,
        "sizeMode.y": 1,
        "sizeAbsolute.x": "auto",
        "style.margin": "0",
        "sizeAbsolute.y": "auto",
        "translation.y": 78.8,
        "sizeMode.z": 1,
        "origin.x": 0.5,
        "origin.y": 0.5,
        "style.zIndex": 8,
        playback: "loop",
        "translation.z": {
          "0": {
            value: Haiku.inject(function(lift) {
              return lift;
            }, "lift"),
            edited: true
          }
        },
        finished: {
          "0": {
            value: Haiku.inject(function(finished) {
              return finished;
            }, "finished"),
            edited: true
          }
        }
      },
      "haiku:Purp-1ca0d350e2c2c8d3": {
        "style.position": "absolute",
        "translation.x": 323.6,
        "style.padding": "0",
        "style.border": "0",
        "sizeMode.x": 1,
        "sizeMode.y": 1,
        "sizeAbsolute.x": "auto",
        "style.margin": "0",
        "sizeAbsolute.y": "auto",
        "translation.y": 285.8,
        "sizeMode.z": 1,
        "origin.x": 0.5,
        "origin.y": 0.5,
        "style.zIndex": { "0": { value: 2, edited: true } },
        playback: "loop",
        "translation.z": 0,
        finished: {
          "0": {
            value: Haiku.inject(function(finished) {
              return finished;
            }, "finished"),
            edited: true
          }
        }
      },
      "haiku:Page-1-2e52bf08a0a02a82": {
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        fillRule: "evenodd"
      },
      "haiku:Artboard-3-d88155353d421f49": {
        fill: "#1B2226",
        fillRule: "nonzero",
        "translation.x": -30,
        "translation.y": -18
      },
      "haiku:slot2_med-f30795478ed8674e": {
        x: 30,
        y: 18,
        width: 93,
        height: 88,
        rx: 10
      },
      "haiku:Page-1-a3f6b9b8c4308d95": {
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        fillRule: "evenodd"
      },
      "haiku:Artboard-3-a13f548ae0473b11": {
        fill: "#1B2226",
        fillRule: "nonzero",
        "translation.x": -30,
        "translation.y": -18
      },
      "haiku:slot2_med-f9b8809de0324c99": {
        x: 30,
        y: 18,
        width: 93,
        height: 88,
        rx: 10
      }
    }
  },
  template: {
    elementName: "div",
    attributes: {
      "haiku-id": "Uifaux-0f23afdde00ee0c7",
      "haiku-title": "Uifaux"
    },
    children: [
      {
        elementName: _code_purp_code,
        attributes: {
          "haiku-id": "Purp-1ca0d350e2c2c8d3",
          "haiku-var": "_code_purp_code",
          "haiku-title": "Purp",
          "haiku-source": "./code/purp/code.js"
        },
        children: []
      },
      {
        elementName: _code_blue_code,
        attributes: {
          "haiku-id": "Blue-9c088d58dfed69fd",
          "haiku-var": "_code_blue_code",
          "haiku-title": "Blue",
          "haiku-source": "./code/blue/code.js"
        },
        children: []
      },
      {
        elementName: _code_orange_code,
        attributes: {
          "haiku-id": "Orange-4eee4f9f4c68dc3e",
          "haiku-var": "_code_orange_code",
          "haiku-title": "Orange",
          "haiku-source": "./code/orange/code.js"
        },
        children: []
      },
      {
        elementName: _code_green_code,
        attributes: {
          "haiku-id": "Green-b274b2bd2601d054",
          "haiku-var": "_code_green_code",
          "haiku-title": "Green",
          "haiku-source": "./code/green/code.js"
        },
        children: []
      },
      {
        elementName: _code_pink_code,
        attributes: {
          "haiku-id": "Pink-2d27044ea4bec9d5",
          "haiku-var": "_code_pink_code",
          "haiku-title": "Pink",
          "haiku-source": "./code/pink/code.js"
        },
        children: []
      },
      {
        elementName: "svg",
        attributes: {
          version: "1.1",
          xmlns: "http://www.w3.org/2000/svg",
          "xmlns:xlink": "http://www.w3.org/1999/xlink",
          "haiku-id": "Slot2-Med-6b3dea5432aece33",
          "haiku-title": "slot2_med",
          "haiku-source": "designs/heroine.sketch.contents/slices/slot2_med.svg"
        },
        children: [
          {
            elementName: "g",
            attributes: { "haiku-id": "Page-1-2e52bf08a0a02a82", id: "Page-1" },
            children: [
              {
                elementName: "g",
                attributes: {
                  "haiku-id": "Artboard-3-d88155353d421f49",
                  id: "Artboard-3"
                },
                children: [
                  {
                    elementName: "rect",
                    attributes: {
                      "haiku-id": "slot2_med-f30795478ed8674e",
                      id: "slot2_med"
                    },
                    children: []
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        elementName: "svg",
        attributes: {
          version: "1.1",
          xmlns: "http://www.w3.org/2000/svg",
          "xmlns:xlink": "http://www.w3.org/1999/xlink",
          "haiku-id": "Slot2-Med-a0d1331f26c4ec66",
          "haiku-title": "slot2_med",
          "haiku-source": "designs/heroine.sketch.contents/slices/slot2_med.svg"
        },
        children: [
          {
            elementName: "g",
            attributes: { "haiku-id": "Page-1-a3f6b9b8c4308d95", id: "Page-1" },
            children: [
              {
                elementName: "g",
                attributes: {
                  "haiku-id": "Artboard-3-a13f548ae0473b11",
                  id: "Artboard-3"
                },
                children: [
                  {
                    elementName: "rect",
                    attributes: {
                      "haiku-id": "slot2_med-f9b8809de0324c99",
                      id: "slot2_med"
                    },
                    children: []
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        elementName: "svg",
        attributes: {
          version: "1.1",
          xmlns: "http://www.w3.org/2000/svg",
          "xmlns:xlink": "http://www.w3.org/1999/xlink",
          "haiku-id": "Ui-Bg-9bb8f6217143b6a1",
          "haiku-title": "ui_bg",
          "haiku-source":
            "designs/heroine.sketch.contents/slices/bg_n_slots.svg#50ea93c31bda"
        },
        children: [
          {
            elementName: "defs",
            attributes: { "haiku-id": "Defs-1f67bc404041a8cf" },
            children: [
              {
                elementName: "filter",
                attributes: {
                  "haiku-id":
                    "E2d7f469247f-D1e397-Filter-1-44e748-0df86d82f849da31",
                  "haiku-title": "filter-1-44e748",
                  id: "e2d7f469247f-d1e397"
                },
                children: [
                  {
                    elementName: "feOffset",
                    attributes: { "haiku-id": "Fe-Offset-3f4caa263e34fb2a" },
                    children: []
                  },
                  {
                    elementName: "feGaussianBlur",
                    attributes: {
                      "haiku-id": "Fe-Gaussian-Blur-f7e18da0b66d08a5"
                    },
                    children: []
                  },
                  {
                    elementName: "feColorMatrix",
                    attributes: {
                      "haiku-id": "Fe-Color-Matrix-44d984f0fdda0821",
                      type: "matrix"
                    },
                    children: []
                  },
                  {
                    elementName: "feMerge",
                    attributes: { "haiku-id": "Fe-Merge-9f0613304988fc1a" },
                    children: [
                      {
                        elementName: "feMergeNode",
                        attributes: {
                          "haiku-id": "Fe-Merge-Node-4f2044f7f412ba24"
                        },
                        children: []
                      },
                      {
                        elementName: "feMergeNode",
                        attributes: {
                          "haiku-id": "Fe-Merge-Node-2c8d1ded813d5d0b"
                        },
                        children: []
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            elementName: "g",
            attributes: { "haiku-id": "Group-8e784ea2e130c70b" },
            children: [
              {
                elementName: "rect",
                attributes: {
                  "haiku-id": "50ea93c31bda-Ui-Bg-ed487866eeb1adb1",
                  "haiku-title": "ui_bg",
                  id: "50ea93c31bda"
                },
                children: []
              }
            ]
          }
        ]
      }
    ]
  }
};



//////////////////
// WEBPACK FOOTER
// ./~/@haiku/taylor-heroine/code/uifaux/code.js
// module id = 527
// module chunks = 35783957827783